import React from 'react';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools } from '../../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, ListContainer, StatusBox } from '../../Reusable'

import FadeIn from 'react-fade-in';
 
const { useHistory } = require('react-router-dom')

interface Props {
  title: string;
}
const CategoriesList: React.FC<Props> = (props) => {

  const history = useHistory()
  const [error, setError] = React.useState('')

  const onFetch = async () => {
    try {
      let ref: any = Fire.store().collection('categories')
        .orderBy('createdAt', 'desc')
      const list = await Fire.list(ref)
      for (const item of list) {
        item.date_created_col = item.createdAt ? Fire.getDateFor(item.createdAt) : new Date()
        item.date_col = item.createdAt ? Time.moment(Fire.getDateFor(item.createdAt)).format('DD/MM/YYYY HH[h]mm') : '-'
      }
      return list
    } catch (err) {
      setError("Impossible de charger les catégories")
      console.warn(err)
    }
    return []
  }

  const sorting = (search: string, items: any[]) => {
    return items.filter((item) => Tools.matchesSearch(search, item.name))
  }
  return (
    <ListContainer
      title={props.title}
      searchTitle={'Rechercher une catégorie...'}
      createTitle={'Créer une catégorie'}
      error={error}
      onFetch={onFetch}
      onSelect={(item) => history.push('/admin/categories/' + item.id)}
      onCreate={() => history.push('/admin/categories/new')}
      sorting={sorting}
      renderColumns={({ refresh }) => ([
        { name: 'Image', accessor: 'image', cell: (item) => (
          <div className="table-preview">
            {item.pictures && item.pictures.length > 0 &&
              <img alt={item.name} src={item.pictures[0]} />
            }
          </div>
        ) },
        { name: 'Nom', string: 'name', sortable: true, accessor: 'name'},
        { name: 'Statut', accessor: 'status', cell: (item) => (
          <StatusBox
            status={item.active ? 'Affiché' : 'Caché'}
            type={item.active ? 'success': 'off'}
            />
        ) },
        { name: 'Créé le', date: 'date_created_col', sortable: true, accessor: 'date_col' },
      ])}
      />
  );
}

export default CategoriesList